import {useEffect, useMemo, useRef} from "react";
import Portal from "components/atom/Portal.tsx";
import {ToastType} from "globals/types/globals.ts";
import {useAppDispatch, useAppSelector} from "config/store";
import Icon from "components/atom/Icon.tsx";
import {globalActions} from "config/store/modules/global.ts";


function ToastsPopup() {
    const dispatch = useAppDispatch()
    const timeoutId = useRef<number | undefined>()
    const toasts: ToastType[] = useAppSelector(state => state.global.toasts)


    useEffect(() => {
        if (toasts.length === 0) {
            return
        }

        clearTimeout(timeoutId.current)
        timeoutId.current = setTimeout(() => {
            dispatch(globalActions.setToast(null))
        }, 3000)
    }, [dispatch, toasts])

    if (toasts.length === 0) {
        return null
    }

    return (
        <Portal>
            <div
                className="fixed left-1/2 top-2 z-30 flex -translate-x-1/2 flex-row items-center justify-center">
                <div className={`w-[300px]`}>
                    {toasts.map((toast, idx) => (
                        <ToastItem toast={toast} key={idx} idx={idx}/>
                    ))}
                </div>

            </div>
        </Portal>
    )
}


function ToastItem(props: { toast: ToastType, idx: number }) {
    const {toast} = props

    const containerClasses = useMemo(() => {
        switch (toast.type) {
            case 'success':
                return 'border-green-500'
            case 'error':
                return 'border-red-500'
            case 'warning':
                return 'border-orange-600'
            default:
                return 'border-gray-500'
        }
    }, [toast])

    const iconName = useMemo(() => {
        switch (toast.type) {
            case 'success':
                return 'check-circle'
            case 'error':
                return 'error'
            case 'warning':
                return 'warning'
            default:
                return null
        }
    }, [toast])

    const iconClasses = useMemo(() => {
        switch (toast.type) {
            case 'success':
                return 'text-green-500'
            case 'error':
                return 'text-red-500'
            case 'warning':
                return 'text-orange-600'
            default:
                return null
        }
    }, [toast])

    const textClasses = useMemo(() => {
        switch (toast.type) {
            case 'success':
                return 'text-black'
            case 'error':
                return 'text-red-500'
            case 'warning':
                return 'text-orange-600'
            default:
                return null
        }
    }, [toast])


    return (
        <div
            className={`rounded-md bg-white px-4 py-2 shadow flex items-center justify-center gap-4 md:flex-row border ${containerClasses}`}>
            {iconName && (
                <Icon name={iconName} className={`h-4 w-4 min-w-4 ${iconClasses}`}/>
            )}
            <p className={`text-left text-sm text-black ${textClasses}`}>
                {toast.message}
            </p>
        </div>
    )
}

export default ToastsPopup
